export const WeatherStackApiAcessKey="9b9f3950e78c56fb493e97b499915e71";
export const CountryDetail="https://restcountries.eu/rest/v2/name/"